import React from "react";
import "./LearnMore.css";
import { NavLink } from "react-router-dom";


const LearnMore = () => {
  return (
    <div className="LearnMore-root">
      {/* HEADER SECTION */}
      <div className="LearnMore-header">
        <div className="LearnMore-header-bg"></div>
        <div className="LearnMore-header-content">
          <h1>
            Your Fastest, Safest & Most Profitable Entry into the
            <span className="LearnMore-header-highlight"> Indian Market</span>
          </h1>
          <p>
            We handle everything — from market entry to guaranteed sales — so you can grow without risk.
          </p>
          

          <NavLink to="/SellInIndiaForm" className="sell-in-india-btn">
 Book a Free Consultation
</NavLink>
        </div>
      </div>

      {/* WHAT IS GATEWAY */}
      <section className="LearnMore-gateway">
        <h2>What Is Gateway to the Indian Market?</h2>
        <p>
          Our service helps B2B, B2C, B2G, D2B & D2C brands enter India without handling logistics, warehousing, or payments themselves. We provide a risk-free process with guaranteed sales plans for qualified products.
        </p>
        <div className="LearnMore-gateway-items">
          <ul>
            <li>
              <span className="LearnMore-icon LearnMore-icon-blue"></span> Risk-Free Entry
            </li>
            <li>
              <span className="LearnMore-icon LearnMore-icon-green"></span> Guaranteed Sales
            </li>
            <li>
              <span className="LearnMore-icon LearnMore-icon-orange"></span> Full Market Access
            </li>
          </ul>
          <div className="LearnMore-gateway-img">
            <img src="https://images.unsplash.com/photo-1520880867055-1e30d1cb001c?auto=format&fit=crop&w=400&q=80" alt="warehouse" />
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="LearnMore-howitworks">
        <h2>How It Works</h2>
        <p>5 Simple Steps to Market Success</p>
        <div className="LearnMore-steps">
          <div className="LearnMore-step LearnMore-step-blue">
            <div className="LearnMore-step-num">1</div>
            <div className="LearnMore-step-label">Product Review</div>
            <div className="LearnMore-step-desc">
              Assess your product’s potential for the Indian market.
            </div>
          </div>
          <div className="LearnMore-step LearnMore-step-green">
            <div className="LearnMore-step-num">2</div>
            <div className="LearnMore-step-label">Market Entry Plan</div>
            <div className="LearnMore-step-desc">
              Strategy, positioning, and pricing for Indian consumers.
            </div>
          </div>
          <div className="LearnMore-step LearnMore-step-orange">
            <div className="LearnMore-step-num">3</div>
            <div className="LearnMore-step-label">Logistics & Compliance</div>
            <div className="LearnMore-step-desc">
              Import, warehousing, customs handled by us.
            </div>
          </div>
          <div className="LearnMore-step LearnMore-step-purple">
            <div className="LearnMore-step-num">4</div>
            <div className="LearnMore-step-label">Sales & Marketing</div>
            <div className="LearnMore-step-desc">
              Online presence, sales execution; we manage payments.
            </div>
          </div>
          <div className="LearnMore-step LearnMore-step-blue">
            <div className="LearnMore-step-num">5</div>
            <div className="LearnMore-step-label">Scale & Repeat</div>
            <div className="LearnMore-step-desc">
              Once proven, we scale your presence nationwide.
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="LearnMore-whychooseus">
        <h2>Why Choose Us</h2>
        <div className="LearnMore-advantages">
          <ul>
            <li>
              <span className="LearnMore-icon LearnMore-icon-green"></span>
              Proven Results <span className="LearnMore-small">$1M–$10M sales achieved</span>
            </li>
            <li>
              <span className="LearnMore-icon LearnMore-icon-blue"></span>
              Zero Hassle
            </li>
            <li>
              <span className="LearnMore-icon LearnMore-icon-pink"></span>
              Full Security <span className="LearnMore-small">24/7 surveillance</span>
            </li>
            <li>
              <span className="LearnMore-icon LearnMore-icon-orange"></span>
              Complete Transparency <span className="LearnMore-small">Unboxing videos</span>
            </li>
          </ul>
          <div className="LearnMore-trusted">
            <div className="LearnMore-trusted-title">Trusted by 200+ Brands</div>
            <div className="LearnMore-trusted-data">
              <div><span className="LearnMore-boldblue">$5M+</span> Sales Generated</div>
              <div><span className="LearnMore-boldgreen">98%</span> Success Rate</div>
              <div><span className="LearnMore-boldorange">30+</span> Categories</div>
            </div>
          </div>
        </div>
      </section>

      {/* COSTS & RESPONSIBILITIES */}
      <section className="LearnMore-costs">
        <h2>Costs & Responsibilities</h2>
        <p>Transparent pricing with no hidden fees</p>
        <div className="LearnMore-costs-columns">
          <div className="LearnMore-costbox">
            <h3>Your Responsibility</h3>
            <ul>
              <li>Import charges & transport</li>
              <li>Product quality & compliance</li>
              <li>Initial product information</li>
            </ul>
          </div>
          <div className="LearnMore-costbox">
            <h3>Our Responsibility</h3>
            <ul>
              <li>Warehousing & inventory management</li>
              <li>Sales, marketing & customer service</li>
              <li>Payment processing & returns</li>
              <li>Local compliance & regulations</li>
            </ul>
          </div>
          <div className="LearnMore-costbox">
            <h3>Pricing</h3>
            <ul>
              <li>6 months FREE trial</li>
              <li>$49/month after trial</li>
              <li>No hidden fees</li>
              <li>Guaranteed sales plan upgrade available</li>
            </ul>
          </div>
        </div>
      </section>

      {/* CLIENT SUCCESS STORIES */}
      <section className="LearnMore-success">
        <h2>Client Success Stories</h2>
        <div className="LearnMore-cards">
          <div className="LearnMore-card LearnMore-card-blue">
            <div className="LearnMore-card-title">Sarah Chen, HealthTech Co.</div>
            <div className="LearnMore-card-result">350%<span> Sales Growth</span></div>
            <p>
              "Gateway India transformed our market entry. From zero to $1M in 6 months with complete peace of mind."
            </p>
          </div>
          <div className="LearnMore-card LearnMore-card-green">
            <div className="LearnMore-card-title">Marcus Weber, Fashion Brand</div>
            <div className="LearnMore-card-result">$1.5M<span> Sales</span></div>
            <p>
              "The guaranteed sales plan exceeded our expectations. India is now our fastest-growing market."
            </p>
          </div>
          <div className="LearnMore-card LearnMore-card-orange">
            <div className="LearnMore-card-title">Priya Sharma, Beauty Products</div>
            <div className="LearnMore-card-result">500%<span> ROI Achieved</span></div>
            <p>
              "Risk-free entry allowed us test the market. Now we’re expanding to Indian cities."
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="LearnMore-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="LearnMore-faq-item">
          <strong>Who handles customs clearance?</strong>
          <p>
            We handle all customs clearance, documentation, and compliance requirements for smooth import.
          </p>
        </div>
      </section>
    </div>
  );
};

export default LearnMore;
